





















import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns } from '../../../store/types';
import { ElementActionsKeys, ElementActionsPayload } from '../../../store/types/element';
import { StageActionsKeys, StageActionsPayload } from '../../../store/types/stageState';

@Component({})
export default class AudioToolbar extends Vue {
  @Getter selectedElement!: RootGettersReturns['selectedElement'];
  @Getter focusState!: RootGettersReturns['focusState'];
  @Getter isGuest!: RootGettersReturns['isGuest'];
  @Getter sharedBoard!: RootGettersReturns['sharedBoard'];

  @Action(ElementActionsKeys.UPDATE_ELEMENT) updateElement!: (payload: ElementActionsPayload['UPDATE_ELEMENT']) => void;
  @Action(StageActionsKeys.SET_FOCUS) focus!: (payload: StageActionsPayload['SET_FOCUS']) => void;

  deleteElement() {
    if (!this.selectedElement) return;
    this.updateElement({
      ...this.selectedElement,
      deleted: true,
    });
  }

  focusElement() {
    if (!this.selectedElement) return;
    this.focus({ board_element: this.focusState ? null : this.selectedElement, withPrevState: true });
  }
}
